import React, { useMemo } from "react";
import { ClinicTabProps, ClinicTabs } from "../clinic/clinicTabs";
import { useTranslateByGender } from "fe-common/locale/useTranslateByGender";
import { MedicalDataDisplaySection } from "./MedicalDataDisplay";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const MedicalDataDisplayTabs = ({
  summarySection,
  ddSection,
  assessmentSection,
  workupSection,
  showDD,
  showInsights,
  loading,
  error,
}: MedicalDataDisplaySection) => {
  const { translate } = useTranslateByGender();
  const tabs: ClinicTabProps[] = useMemo(() => {
    const activeTabs: ClinicTabProps[] = [
      {
        label: translate("SUMMARY_TITLE"),
        content: summarySection,
        padding: "12px 0",
      },
    ];
    if (!error && showInsights && showDD)
      activeTabs.push({
        label: translate("POSSIBLE_CAUSES"),
        content: ddSection,
        padding: "12px 0",
      });
    if (!error && showInsights)
      activeTabs.push(
        {
          label: translate("ASSESSMENT"),
          content: assessmentSection,
        },
        { label: translate("SUGGESTED_WORKUP"), content: workupSection },
      );

    return activeTabs;
  }, [
    summarySection,
    ddSection,
    assessmentSection,
    workupSection,
    showDD,
    showInsights,
  ]);

  return <ClinicTabs tabs={tabs} style={{ flex: 1 }} loading={loading} />;
};
